import jrImage from '../assets/images/jr.png';
import rkImage from '../assets/images/rk.png';
import seImage from '../assets/images/se.png';
import nhImage from '../assets/images/nh.png';
import eqImage from '../assets/images/eq.png';
import jwImage from '../assets/images/jw.jpg';
import kpImage from '../assets/images/kp.jpg';
import lpImage from '../assets/images/lp.jpg';

// Portfolio logos are served by the brand-kit CDN (the single source for brand
// assets). brand-kit names variants by the text colour, not the background:
// `-dark` is dark text for light backgrounds, `-light`/`-white` is for dark ones.
const PORTCO_LOGOS = 'https://brand.twobearcapital.com/svg/portcos';

export interface SpeakerCompany {
  name: string;
  /** Transparent logo for light backgrounds. */
  logoUrl: string;
  /** Transparent logo for dark backgrounds, when brand-kit has one. */
  logoUrlDark?: string;
}

export interface Speaker {
  id: string;
  name: string;
  picture?: string;
  title?: string;
  bio?: string;
  linkedinUrl?: string;
  company?: SpeakerCompany;
}

export const speakers: Speaker[] = [
  {
    id: 'mg',
    name: 'Mike Goguen',
    picture:
      'https://cdn.prod.website-files.com/651744326a6bfab19cbef393/678804a8749bcd91a3e2239c_TBC_Photos_TeamPage_Mike-37.png',
    title: 'Founder and Managing Partner',
  },
  {
    id: 'ss',
    name: 'Seth Strattan, PhD',
    picture:
      'https://cdn.prod.website-files.com/651744326a6bfab19cbef393/651df18d50681e5712906bb5_651de0f0aec73606a8e7018a_TBC_Photos_TeamPage_Seth.jpeg',
    title: 'General Partner',
  },
  {
    id: 'js',
    name: 'John Sullivan',
    picture:
      'https://cdn.prod.website-files.com/651744326a6bfab19cbef393/651df18db052a4c56e1c0aa8_651de0c718c50f92e1728601_TBC_Photos_TeamPage_John.jpeg',
    title: 'Venture Partner',
  },
  {
    id: 'ja',
    name: 'Jenna Aronson, PhD',
    picture:
      'https://cdn.prod.website-files.com/651744326a6bfab19cbef393/651df18d708d32af7fc16e65_651de14f799bcbc1401a290a_TBC_Photos_TeamPage_Jenna.png',
    title: 'Principal',
  },
  {
    id: 'as',
    name: 'Avery Sonnenberg, PhD',
    picture:
      'https://cdn.prod.website-files.com/651744326a6bfab19cbef393/651df18d31a79c553c94196f_651de10a50681e57127e033f_TBC_Photos_TeamPage_Avery.png',
    title: 'Principal',
  },
  {
    id: 'ef',
    name: 'Eric Fulton',
    picture:
      'https://cdn.prod.website-files.com/651744326a6bfab19cbef393/6788047c5fc61cf7b79054b9_TBC_Photos_TeamPage_Eric.png',
    title: 'Venture Partner',
  },
  {
    id: 'tv',
    name: 'Tim Veil',
    picture:
      'https://cdn.prod.website-files.com/651744326a6bfab19cbef393/66ad4adccb57f7de2e03af29_TBC_Photos_TeamPage_Tim%20Veil.jpg',
    title: 'Principal',
  },
  {
    id: 'ma',
    name: 'Mark Adam, PhD',
    picture:
      'https://cdn.prod.website-files.com/651744326a6bfab19cbef393/651df18e9c211dc2a1c565f4_651de16e020521fcc3b7097d_TBC_Photos_TeamPage_Mark.jpeg',
    title: 'Partner',
  },
  {
    id: 'jr',
    name: 'John Rowell',
    picture: jrImage,
    title: 'Co-Founder and CEO, Revenium',
  },
  {
    id: 'rk',
    name: 'Rebecca Krauthammer',
    picture: rkImage,
    title: 'Co-Founder and CEO, QuSecure',
  },
  {
    id: 'cn',
    name: 'Cris Neckar',
    picture:
      'https://cdn.prod.website-files.com/651744326a6bfab19cbef393/651df18d0e471d05c6a4a86a_651de0e2b052a4c56e0bc6bb_TBC_Photos_TeamPage_Cris.jpeg',
    title: 'Partner',
  },
  {
    id: 'kg',
    name: 'Kristen Getchell, PhD',
    picture:
      'https://cdn.prod.website-files.com/651744326a6bfab19cbef393/68a8e32aafd66f2e30037a1b_kristen-getchell.webp',
    title: 'Head of Platform',
  },
  {
    id: 'nw',
    name: 'Neil White',
    picture:
      'https://cdn.prod.website-files.com/651744326a6bfab19cbef393/686c26af77ce376f5bf3f0b9_Neil-short.jpg',
    title: 'Partner',
  },
  {
    id: 'se',
    name: 'Server Ertem',
    picture: seImage,
    title: 'CEO, Sanavia Oncology',
  },
  {
    id: 'jm',
    name: 'Jeff Miller',
    picture:
      'https://cdn.prod.website-files.com/651744326a6bfab19cbef393/6788046687f995e5483e3913_TBC_Photos_TeamPage_Jeff.png',
    title: 'Operating Partner',
  },
  {
    id: 'ac',
    name: 'Mollie Colangelo',
    picture:
      'https://cdn.prod.website-files.com/651744326a6bfab19cbef393/686c243945de480d544bf514_Amalia-short-p-800.jpg',
    title: 'Principal',
  },
  {
    id: 'nh',
    name: 'Nicholas Hertz, PhD',
    picture: nhImage,
    title: 'Founder and CEO, Montara Therapeutics',
    linkedinUrl: 'https://www.linkedin.com/in/nicholas-hertz-ph-d-9613785/',
    company: {
      name: 'Montara Therapeutics',
      logoUrl: `${PORTCO_LOGOS}/montara/montara-wordmark-dark.svg`,
      logoUrlDark: `${PORTCO_LOGOS}/montara/montara-wordmark-light.svg`,
    },
  },
  {
    id: 'lp',
    name: 'Lindsay Pino',
    picture: lpImage,
    title: 'Co-Founder and CTO, Talus Bio',
    linkedinUrl: 'https://www.linkedin.com/in/lindsaykpino/',
    company: {
      name: 'Talus Bio',
      logoUrl: `${PORTCO_LOGOS}/talus/talus-wordmark-dark.svg`,
      logoUrlDark: `${PORTCO_LOGOS}/talus/talus-wordmark-light.svg`,
    },
  },
  {
    id: 'kp',
    name: 'Kevin Pomplun',
    picture: kpImage,
    title: 'Co-Founder and CEO, LENS',
    linkedinUrl: 'https://www.linkedin.com/in/kevinpomplun/',
    company: {
      name: 'LENS',
      logoUrl: `${PORTCO_LOGOS}/lens/lens-primary.svg`,
      logoUrlDark: `${PORTCO_LOGOS}/lens/lens-white.svg`,
    },
  },
  {
    id: 'jw',
    name: 'James Winebrenner',
    picture: jwImage,
    title: 'CEO, Elisity',
    linkedinUrl: 'https://www.linkedin.com/in/jamesmwinebrenner/',
    company: {
      name: 'Elisity',
      logoUrl: `${PORTCO_LOGOS}/elisity/elisity-wordmark.svg`,
      logoUrlDark: `${PORTCO_LOGOS}/elisity/elisity-wordmark-white.svg`,
    },
  },
  {
    id: 'eq',
    name: 'Eddie Qureshi',
    picture: eqImage,
    title: 'Founder and CEO, Rainfall Health',
    linkedinUrl: 'https://www.linkedin.com/in/ahmed-eddiequreshi/',
    company: {
      name: 'Rainfall Health',
      logoUrl: `${PORTCO_LOGOS}/rainfall/horizontal-primary.svg`,
    },
  },
];

// Helper function to get speakers by IDs
export function getSpeakersByIds(ids: string[]): Speaker[] {
  return ids
    .map((id) => speakers.find((speaker) => speaker.id === id))
    .filter((speaker): speaker is Speaker => speaker !== undefined);
}
